/*!
 * CoverPop 2.5.1
 * http://coverpopjs.com
 *
 * Copyright (c) 2015 Tyler Pearson
 * Licensed under the MIT license: http://www.opensource.org/licenses/mit-license.php
 */

! function (e) {
	"use strict";
	var o = {
			coverId: "CoverPop-cover",
			expires: 30,
			closeClassNoDefault: "CoverPop-close",
			closeClassDefault: "CoverPop-close-go",
			openClassDefault: "CoverPop-open",
			cookieName: "_CoverPop",
			onPopUpOpen: null,
			onPopUpClose: null,
			forceHash: "splash",
			delayHash: "go",
			closeOnEscape: !0,
			delay: 0,
			hideAfter: null
		},
		s = {},
		t = {
			hasClass: function (e, o) {
				return new RegExp("(\\s|^)" + o + "(\\s|$)").test(e.className)
			},
			addClass: function (e, o) {
				t.hasClass(e, o) || (e.className += (e.className ? " " : "") + o)
			},
			removeClass: function (e, o) {
				t.hasClass(e, o) && (e.className = e.className.replace(new RegExp("(\\s|^)" + o + "(\\s|$)"), " ").replace(/^\s+|\s+$/g, ""))
			},
			addListener: function (e, o, s) {
				e.addEventListener ? e.addEventListener(o, s, !1) : e.attachEvent && e.attachEvent("on" + o, s)
			},
			removeListener: function (e, o, s) {
				e.removeEventListener ? e.removeEventListener(o, s, !1) : e.detachEvent && e.detachEvent("on" + o, s)
			},
			isFunction: function (e) {
				var o = {};
				return e && "[object Function]" === o.toString.call(e)
			},
			setCookie: function (e, o) {
				var s = new Date;
				s.setTime(+s + 864e5 * o), document.cookie = e + "=true; expires=" + s.toGMTString() + "; path=/"
			},
			hasCookie: function (e) {
				return -1 !== document.cookie.indexOf(e) ? !0 : !1
			},
			hashExists: function (e) {
				return -1 !== window.location.hash.indexOf(e) ? !0 : !1
			},
			preventDefault: function (e) {
				e.preventDefault ? e.preventDefault() : e.returnValue = !1
			},
			mergeObj: function (e, o) {
				for (var s in o) e[s] = o[s]
			}
		},
		n = function (s) {
			o.closeOnEscape && 27 === s.keyCode && e.close()
		},
		l = function () {
			if (null !== o.onPopUpOpen) {
				if (!t.isFunction(o.onPopUpOpen)) throw new TypeError("CoverPop open callback must be a function.");
				o.onPopUpOpen.call()
			}
		},
		a = function () {
			if (null !== o.onPopUpClose) {
				if (!t.isFunction(o.onPopUpClose)) throw new TypeError("CoverPop close callback must be a function.");
				o.onPopUpClose.call()
			}
		};
	e.open = function () {
		var a, c;
		if (t.hashExists(o.delayHash)) return void t.setCookie(o.cookieName, 1);
		if (t.addClass(s.html, o.openClassDefault), s.closeClassNoDefaultEls.length > 0)
			for (a = 0, c = s.closeClassNoDefaultEls.length; c > a; a++) t.addListener(s.closeClassNoDefaultEls[a], "click", function (o) {
				o.target === this && (t.preventDefault(o), e.close())
			});
		if (s.closeClassDefaultEls.length > 0)
			for (a = 0, c = s.closeClassDefaultEls.length; c > a; a++) t.addListener(s.closeClassDefaultEls[a], "click", function (o) {
				o.target === this && e.close()
			});
		t.addListener(document, "keyup", n), l()
	}, e.close = function () {
		t.removeClass(s.html, o.openClassDefault), t.setCookie(o.cookieName, o.expires), t.removeListener(document, "keyup", n), a()
	}, e.init = function (n) {
		navigator.cookieEnabled && (t.mergeObj(o, n), s = {
			html: document.getElementsByTagName("html")[0],
			cover: document.getElementById(o.coverId),
			closeClassDefaultEls: document.querySelectorAll("." + o.closeClassDefault),
			closeClassNoDefaultEls: document.querySelectorAll("." + o.closeClassNoDefault)
		}, (!t.hasCookie(o.cookieName) || t.hashExists(o.forceHash)) && (0 === o.delay ? e.open() : setTimeout(e.open, o.delay), o.hideAfter && setTimeout(e.close, o.hideAfter + o.delay)))
	}, e.start = function (o) {
		e.init(o)
	}
}(window.CoverPop = window.CoverPop || {});

(function ($) {

	$(document).ready(function () {

		// I only have one form on the page but you can be more specific if need be.
		var $mcMailForm = $('#mc-embedded-subscribe-form');
		$('#mc-embedded-subscribe').addClass('disabled');

		$("form#mc-embedded-subscribe-form").submit(function (e) {
			if (!$("#agree:checked").length) {
				return false;
			}
			e.preventDefault();
			register($mcMailForm);
		});


		$('#agree').on("change", function () {
			if (!$("#agree:checked").length) {
				$('#mc-embedded-subscribe').addClass('disabled');
			} else {
				$('#mc-embedded-subscribe').removeClass('disabled');
				$('label[for="agree"]').parent('p').removeClass('error_special').children('span').hide();
			}
		}).trigger('change');

		$('#mc-embedded-subscribe.btn').on('click', function (e) {
			if ($(this).hasClass('disabled')) {
				$('.help-error').remove();
				$('label[for="agree"]').addClass('error_underline').parent('p').addClass('error_special').append('<span class="help-error">You must tick this box to proceed</span>');
			} else {
				e.preventDefault();
				register($mcMailForm);
			}
		});

		$('input').on('input', function () {
			$('.no-content').removeClass('error');
		});

		$('.CoverPop-close, #CoverPop-cover').click(function () {
			CoverPop.close();
		});

		function register($mcMailForm) {
			$.ajax({
				type: $mcMailForm.attr('method'),
				url: $mcMailForm.attr('action'),
				data: $mcMailForm.serialize(),
				cache: false,
				dataType: 'json',
				contentType: "application/json; charset=utf-8",
				error: function (err) {
					console.log('connection error contact hello@WEMAKEWEBSITES.COM')
				},
				success: function (data) {
					if (data.result != "success") {
						// $('.no-content').addClass('error').html(data.msg);
						console.log(data.msg)
					} else {
						if ($('.flip-container').is(':visible')) {
							$('.flip-container').addClass('form-complete');
						}
						$('.mc-field-group').removeClass('error');
						$('#mc_embed_signup').html('<h3>Great! this is done a confirmation email is being sent to you</h3>');
						$("body").delay(2500).queue(function () {
							// CoverPop.close();
						});
						$.cookie("exitIntent", "signedup", {
							expires: 365,
							path: '/'
						});
					}
				}
			});

		}

		function startPopup() {
			CoverPop.start({
				coverId: 'CoverPop-cover', // set default cover id
				expires: 365, // duration (in days) before it pops up again
				closeClassNoDefault: 'CoverPop-close', // close if someone clicks an element with this class and prevent default action
				closeClassDefault: 'CoverPop-close-go', // close if someone clicks an element with this class and continue default action
				cookieName: '_CoverPop', // to change the plugin cookie name
				onPopUpOpen: function () {}, // on popup open callback function
				onPopUpClose: function () {
					if ($.cookie('exitIntent') != 'signedup') { // Check if signed-up before resetting 15 minute cookie
						var date = new Date();
						var minutes = 10;
						date.setTime(date.getTime() + (minutes * 60 * 1000));
						// $.cookie("exitIntent", "true", { expires: date , path: '/' });
						$.cookie("exitIntent", "true", {
							expires: 365,
							path: '/'
						});
					}
				}, // on popup close callback function
				forceHash: 'splash', // hash to append to url to force display of popup (e.g. http://yourdomain.com/#splash)
				delayHash: 'go', // hash to append to url to delay popup for 1 day (e.g. http://yourdomain.com/#go)
				closeOnEscape: true, // close if the user clicks escape
				delay: 0, // set an optional delay (in milliseconds) before showing the popup
				hideAfter: null // set an optional time (in milliseconds) to autohide
			});
		}


		$(".CoverPop-content").click(function (e) {
			e.stopPropagation();
		})

		function delayIntent() {
			// Exit intent
			function addEvent(obj, evt, fn) {
				if (obj.addEventListener) {
					obj.addEventListener(evt, fn, false);
				} else if (obj.attachEvent) {
					obj.attachEvent("on" + evt, fn);
				}
			}


			// Exit intent trigger
			addEvent(document, 'mouseout', function (evt) {
				if ($.cookie('exitIntent') == null) {
					console.log('new user');
					if (evt.toElement == null && evt.relatedTarget == null) {
						$.removeCookie('_CoverPop', {
							path: '/'
						}); // => true
						setTimeout(startPopup, 50);
					};
				} else {
					console.log('already sign up or closed')
				}
			});

			console.log('intentInit');
		}

		setTimeout(delayIntent, 1);
	});

})(jQuery);